import { DEFECT_STATUS_OPTIONS, TICKET_STATUS_OPTIONS } from "@/lib/constants";

export const TASK_CATEGORIES = [
  { value: "open", label: "Alle meine Aufgaben" },
  { value: "today", label: "Heute fällig" },
  { value: "overdue", label: "Überfällig" },
  { value: "upcoming", label: "Demnächst fällig" },
  { value: "defects", label: "Offene Mängel" },
  { value: "tickets", label: "Offene Tickets" },
  { value: "inspections", label: "Prüfungen & Wartungen" },
  { value: "feedback", label: "Ausstehende Rückmeldungen" },
  { value: "done", label: "Abgeschlossen" },
];

export const TEAM_CATEGORIES = [
  { value: "open", label: "Alle offenen" },
  { value: "unassigned", label: "Nicht zugewiesen" },
  { value: "overdue", label: "Überfällig" },
  { value: "today", label: "Heute fällig" },
  { value: "high", label: "Hoch / Kritisch" },
  { value: "stale", label: "Ohne Bearbeitung (14 Tage)" },
  { value: "feedback", label: "Rückmeldungen & Freigaben" },
  { value: "done", label: "Abgeschlossen" },
];

export const TASK_PRIORITY = {
  kritisch: { label: "Kritisch", cls: "bg-red-600 text-white border-red-600" },
  hoch: { label: "Hoch", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  normal: { label: "Normal", cls: "bg-slate-50 text-slate-600 border-slate-200" },
  niedrig: { label: "Niedrig", cls: "bg-white text-slate-400 border-slate-200" },
};

export const TASK_TYPES = { defect: "Mangel", ticket: "Ticket", inspection: "Prüfung/Wartung" };

export const SORTS = [
  { value: "due", label: "Fälligkeit" },
  { value: "priority", label: "Priorität" },
  { value: "updated", label: "Aktualität" },
  { value: "project", label: "Objekt" },
];

export const statusOptionsFor = (type) => (type === "defect" ? DEFECT_STATUS_OPTIONS : type === "ticket" ? TICKET_STATUS_OPTIONS : []);

export function sourceLink(t) {
  if (t.type === "inspection") return "/pruefungen";
  if (t.plan_id && t.position_id) return `/plans/${t.plan_id}?position=${t.position_id}&tab=${t.type === "defect" ? "maengel" : "tickets"}`;
  return t.project_id ? `/projects/${t.project_id}` : null;
}

export const fmtDate = (s) => (s ? s.slice(0, 10).split("-").reverse().join(".") : "—");
